export function isOdd(n: number) {
  return Math.abs(n % 2) == 1;
}
